"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthProviders = void 0;
exports.OAuthProviders = {
    Oura: "oura",
    Fitbit: "fitbit",
    Garmin: "garmin",
    Strava: "strava",
    Wahoo: "wahoo",
    Ihealth: "ihealth",
    Withings: "withings",
    GoogleFit: "google_fit",
    DexcomV3: "dexcom_v3",
    Polar: "polar",
    Cronometer: "cronometer",
    Omron: "omron",
    WhoopV2: "whoop_v2",
};
